export default {
  styleOverrides: {
    root: {
      height: 56,
    },
    toolbar: {
      // height: 56,
    },
  },
};
